import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from 'bootstrap-icons/icons/hdd-stack.svg'
import _imports_1 from 'bootstrap-icons/icons/people.svg'
import _imports_2 from 'bootstrap-icons/icons/recycle.svg'
import _imports_3 from 'svg-country-flags/svg/gb.svg'
import _imports_4 from 'svg-country-flags/svg/cz.svg'
import _imports_5 from 'svg-country-flags/svg/in.svg'
import _imports_6 from 'svg-country-flags/svg/gr.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "row d-flex align-items-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col description" }, [
    /*#__PURE__*/_createVNode("h4", null, "hello,"),
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" my name is Bagrat. "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" I'm a software engineer. ")
    ]),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" drop me an "),
      /*#__PURE__*/_createVNode("a", { href: "mailto:hello@saatsazov.com" }, "email"),
      /*#__PURE__*/_createTextVNode(". ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "row features gx-5 gy-5 text-center",
  style: {"padding-top":"500px"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-4 mx-auto" }, [
    /*#__PURE__*/_createVNode("img", {
      width: "30",
      height: "30",
      src: _imports_0
    }),
    /*#__PURE__*/_createVNode("h4", null, "high load"),
    /*#__PURE__*/_createVNode("p", null, " I’ve been developing backends for more than 8 years. I'm able to analyze bottlenecks, optimize databases, and add caching layers. In order to effectively serve all customers. ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-md-4 mx-auto" }, [
    /*#__PURE__*/_createVNode("img", {
      width: "30",
      height: "30",
      src: _imports_1
    }),
    /*#__PURE__*/_createVNode("h4", null, "team leader"),
    /*#__PURE__*/_createVNode("p", null, " I can manage the development process. Hire, teach and lead a team. Taught four developers from the ground up and was a mentor for others. ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-md-4 mx-auto" }, [
    /*#__PURE__*/_createVNode("img", {
      width: "30",
      height: "30",
      src: _imports_2
    }),
    /*#__PURE__*/_createVNode("h4", null, "iterative mindset"),
    /*#__PURE__*/_createVNode("p", null, " Bringing projects to a market ASAP. Observe, analyze, and move forward: throw it away or iterate without overengineering. ")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "row mt-10 gx-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-2" }, [
    /*#__PURE__*/_createVNode("h3", null, "portfolio")
  ])
], -1)
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("all projects -> ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "row mt-10 gx-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-2" }, [
    /*#__PURE__*/_createVNode("h3", null, "feedbacks")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "row mt-1 gx-5 gy-5 feedback justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-lg-5 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_3,
          title: "UK"
        }),
        /*#__PURE__*/_createTextVNode(" Dominic Nyarambi ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "Co Founder, OneMoon Digital"),
      /*#__PURE__*/_createVNode("p", null, " Bagrat is a very hard working individual who is very professional in their approach to work and is very logical. Bagrat follows best practices when it comes to coding and ensures the clients needs are met and thought of at every interval. Bagrat is a joy to work with and he never disappoints! ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-lg-3 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_4,
          title: "Czech Republic"
        }),
        /*#__PURE__*/_createTextVNode(" Ishtvan Syuch ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "CEO, Česko Evropská Agentura"),
      /*#__PURE__*/_createVNode("p", null, " A responsible partner who did a good job. Fixed mess with documents. Solved the problem of storing personal information of our clients. Simplified and automated workflow. ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-lg-4 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_3,
          title: "UK"
        }),
        /*#__PURE__*/_createTextVNode(" Sharon Rose ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "Co Founder, Be Major learning academy"),
      /*#__PURE__*/_createVNode("p", null, " What a pleasure it’s been working with Bagrat and the entire team at OneMoon Digital. He has been along this journey with us as a present help and we are grateful for all his hard work. We’d definitely recommend him! ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-lg-2 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_5,
          title: "India"
        }),
        /*#__PURE__*/_createTextVNode(" Vishal Dharankar ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "CTO, Merokirana"),
      /*#__PURE__*/_createVNode("p", null, " Was a good deal to work with Bagrat, he knows what he is doing, skilled and smart. ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-lg-4 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_3,
          title: "UK"
        }),
        /*#__PURE__*/_createTextVNode(" Emma Bartholomew ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "PR, Events & Brand Strategy"),
      /*#__PURE__*/_createVNode("p", null, " Bagrat worked tirelessly to find the solutions needed for our startup. He was responsive, creative, innovative and resourceful in his tenacious approach to get everything right for us. Highly recommended. ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-lg-6 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_4,
          title: "Czech Republic"
        }),
        /*#__PURE__*/_createTextVNode(" Pavel Niedoba ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "CEO, Simplecoin"),
      /*#__PURE__*/_createVNode("p", null, " Bagrat worked for Simplecoin 3 years 2 months. He is very intelligent and fast learning. He is proficient in all levels in PHP. Most of the time at Simplecoin he was working on rather big piece of code built on top of Yii 2.0 framework. He has advanced skills in front-end development too including React and Typescript. He also learned Kotlin quickly. I suppose he can adopt new programming language in matter of weeks ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "col-lg-6 col-md-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "" }, [
      /*#__PURE__*/_createVNode("h4", null, [
        /*#__PURE__*/_createVNode("img", {
          height: "15",
          src: _imports_6,
          title: "Greece"
        }),
        /*#__PURE__*/_createTextVNode(" Lefteris Catsaros ")
      ]),
      /*#__PURE__*/_createVNode("h5", null, "CEO, CIMA SOFTWARE EMEA"),
      /*#__PURE__*/_createVNode("p", null, " Bagrat demonstrated a great ability to understand our problem, read existing code and implement the required changes/improvements. He was always on time, for meetings or deliverables, which is really important for us. In general he showcased his strict professionalism and a lot from his technical skills. Our project was 'on specs', 'on budget' and 'on time', therefore it will be a pleasure to work with him again in a future project ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_portfolio_preview = _resolveComponent("portfolio-preview")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.portfolioItems, (p) => {
        return (_openBlock(), _createBlock(_component_portfolio_preview, {
          key: p.name,
          data: p
        }, null, 8, ["data"]))
      }), 128))
    ]),
    _createVNode(_component_router_link, {
      class: "nav-link",
      to: "/portfolio"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _hoisted_6,
    _hoisted_7
  ], 64))
}